<div class="modal-header">
    <h5 class="modal-title text-center" [translate]="'SMARTLOCKER_TRANSFER_TITLE'"></h5>
    <span class="close" (click)="close()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="smartlockerTransferForm">
        <fieldset>
            <div class="row align-items-center">
                <label
                    for="awbPackageNumber"
                    class="col-form-label text-start"
                    [translate]="'SMARTLOCKER_SCAN_AWB_PACKAGE_LABEL'"
                ></label>
                <pace-core-text-input
                    id="awbPackageNumber"
                    [(model)]="model.awbPackageNumber"
                    [parentForm]="formChildren"
                ></pace-core-text-input>
            </div>
        </fieldset>
        @if (destinationDoors.value.length > 0) {
            <div class="mt-3">
                <label
                    for="destinationDoor"
                    class="col-form-label"
                    [translate]="'SMARTLOCKER_SELECT_DESTINATION_DOOR_LABEL'"
                ></label>
                <pace-core-dropdown
                    id="destinationDoor"
                    [(model)]="destinationDoors"
                    [parentForm]="formChildren"
                ></pace-core-dropdown>
            </div>
            <div class="mt-5">
                @if (destinationDoors.selectedEntry) {
                    <h6 class="fw-bold mb-3 px-1" [translate]="'SMARTLOCKER_TRANSFER_DETAILS_LABEL'"></h6>

                    <div class="smartlocker-materials-container p-3">
                        <!-- Origin Row -->
                        <div class="row align-items-center">
                            <div class="col-1 me-3 text-muted">
                                <fa-icon [icon]="faMapMarkerAlt" size="lg"></fa-icon>
                            </div>
                            <div class="col-10">
                                <div
                                    class="small text-muted"
                                    [translate]="'SMARTLOCKER_TRANSFER_DETAILS_FROM_LABEL'"
                                ></div>
                                <div class="fw-bold">
                                    {{ originDoorDetails }}
                                </div>
                            </div>
                        </div>

                        <div class="py-2 ps-4">
                            <fa-icon [icon]="faArrowDown" class="text-muted opacity-50" size="xs"></fa-icon>
                        </div>

                        <!-- Destination Row -->
                        <div class="row align-items-center">
                            <div class="col-1 me-3 text-muted">
                                <fa-icon [icon]="faDoorOpen" size="lg"></fa-icon>
                            </div>
                            <div class="col-10">
                                <div
                                    class="small text-muted"
                                    [translate]="'SMARTLOCKER_TRANSFER_DETAILS_TO_LABEL'"
                                ></div>
                                <div class="fw-bold">
                                    {{ destinationDoors.selectedEntry.displayName }}
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        }
        @if (model.awbPackageNumber.value && !model.isMatchingAwbPackageNumber()) {
            <div class="d-flex text-center flex-column mt-5 gap-3">
                <div class="fw-bold" [translate]="'SMARTLOCKER_SCANNED_WRONG_PACKAGE_MESSAGE_ONE'"></div>
                <div [translate]="'SMARTLOCKER_SCANNED_WRONG_PACKAGE_MESSAGE_TWO'"></div>
            </div>
        }
    </form>

    @switch (transferState) {
        @case (availableStates.InProgress) {
            <div class="align-items-center justify-content-center mt-5">
                <progressbar [value]="100" type="info">
                    {{ 'SMARTLOCKER_TRANSFER_IN_PROGRESS_LABEL' | translate }}
                </progressbar>
            </div>
        }
        @case (availableStates.Success) {
            <div class="d-flex flex-column align-items-start mt-5">
                <div [translate]="'SMARTLOCKER_TRANSFER_PLACEMENT_PROMPT'"></div>
            </div>
        }
        @case (availableStates.Failed) {
            <div class="d-flex flex-column align-items-start mt-5">
                <div [translate]="'SMARTLOCKER_TRANSFER_FAILED_MESSAGE'"></div>
            </div>
        }
    }
</div>
<div class="modal-footer">
    @switch (transferState) {
        @case (availableStates.Success) {
            <button
                type="button"
                class="btn btn-primary"
                (click)="close()"
                [translate]="'SMARTLOCKER_DONE_BTN_LABEL'"
            ></button>
        }
        @case (availableStates.Failed) {
            <button
                type="button"
                class="btn btn-primary"
                (click)="getDestinationAccessCode()"
                [translate]="'SMARTLOCKER_RETRY_BTN_LABEL'"
            ></button>
        }
        @case (availableStates.NotStarted) {
            <button
                type="button"
                class="btn btn-primary px-4"
                [disabled]="!smartlockerTransferForm.valid"
                (click)="getDestinationAccessCode()"
                [translate]="'SMARTLOCKER_TRANSFER_PROCEED_BTN_LABEL'"
            ></button>
        }
    }
</div>
